import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface DeleteOCClaimsRequestParams {
  fbocKeys: string;
}

export const deleteOCClaimsAPI = (params: DeleteOCClaimsRequestParams) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.OVERCHARGE_CLAIM}/DeleteClaim`,
  });
};

export type DeleteOCClaimsResponse = undefined;

export const deleteOCClaims = async (params: DeleteOCClaimsRequestParams): Promise<DeleteOCClaimsResponse> => {
  const response: AxiosResponse<DeleteOCClaimsResponse> = await deleteOCClaimsAPI(params);
  return response.data;
};
